import { useBack } from "@website/hooks/back";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { useMemo } from "react";

export function BackButton({ isHomePage }: { isHomePage?: boolean }) {
  const { goBack } = useBack();

  const search = useMemo(() => {
    if (typeof window === "object") {
      return new URLSearchParams(window.location.search);
    }
    return null;
  }, []);

  function onBackHomePageClick() {
    const isPwa = search?.get("ispwa");

    //TODO: add code back from android or ios
    if (isPwa) {
      window.close();
      return;
    }

    window.location.assign("snpjekhomepage://");
  }

  return (
    <Button
      EndIcon={<MaterialIcon name="arrow_forward" variant="outlined" />}
      aria-label="close"
      className="lg:!hidden"
      color="neutral"
      equalDimension
      onClick={isHomePage ? onBackHomePageClick : goBack}
      size="small"
      variant="text"
    />
  );
}
